import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onAuthed }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem("ms_admin_token", data.token);
      toast.success("Welcome back.");
      onAuthed(data.token);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg =
        typeof detail === "string"
          ? detail
          : err?.response?.status === 429
            ? "Too many attempts. Try again later."
            : "Login failed.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login"
      className="min-h-screen w-full bg-black text-white flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="eyebrow mb-8">/ Restricted · Admin</div>
        <h1 className="font-serif italic text-5xl sm:text-6xl font-light tracking-tighter leading-[0.95] mb-3">
          Momenta
        </h1>
        <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tighter mb-12">
          Studios.
        </h2>

        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-underline"
              placeholder="Enter password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="group inline-flex items-center gap-6 bg-white text-black hover:bg-white/85 disabled:opacity-60 px-8 py-4 text-[11px] tracking-[0.3em] uppercase transition-colors"
          >
            <span>{loading ? "Verifying" : "Enter"}</span>
            <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">
              →
            </span>
          </button>
        </form>

        <a
          href="/"
          data-testid="admin-back-home"
          className="mt-16 inline-block eyebrow text-white/40 hover:text-white link-underline"
        >
          ← Back to site
        </a>
      </div>
    </div>
  );
}
